// Axon Muscle - Premium Muscle Supplements & Performance Nutrition
// Modern dark premium e-commerce store with electric blue/cyan aesthetic

// ============================================
// SITE IMAGES - Dark Gym/Fitness Theme
// ============================================
export const siteImages = {
  // Hero images - dramatic dark gym
  heroMain: 'https://images.unsplash.com/photo-1590487988256-9ed24133863e?w=1920&q=80',
  heroSecondary: 'https://images.unsplash.com/photo-1646492169621-d8da8016354a?w=1920&q=80',
  heroLifestyle: 'https://images.unsplash.com/photo-1521805103424-d8f8430e8933?w=1920&q=80',
  
  // Section backgrounds
  ctaBackground: 'https://images.unsplash.com/photo-1544033527-b192daee1f5b?w=1920&q=80',
  featuredBackground: 'https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?w=1920&q=80',
  powerBackground: 'https://images.unsplash.com/photo-1590487988256-9ed24133863e?w=1920&q=80',
  
  // Page banners
  shopBanner: 'https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?w=1920&q=80',
  aboutBanner: 'https://images.unsplash.com/photo-1521805103424-d8f8430e8933?w=1920&q=80',
  contactBanner: 'https://images.unsplash.com/photo-1544033527-b192daee1f5b?w=1920&q=80',
  returnsBanner: 'https://images.unsplash.com/photo-1646492169621-d8da8016354a?w=1920&q=80',
  privacyBanner: 'https://images.unsplash.com/photo-1590487988256-9ed24133863e?w=1920&q=80',
};

// ============================================
// PLACEHOLDER PRODUCT IMAGE
// ============================================
const PLACEHOLDER_IMAGE = null; // Will render as gray box

export const SHIPPING_NOTICE = 'We ship within the USA via USPS';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '3-5 business days';
export const FREE_SHIPPING_THRESHOLD = 99;

// Card Statement Descriptor
export const CARD_DESCRIPTOR = 'AXON';

// Hosting Provider
export const HOSTING_PROVIDER = 'Hostinger';

// Contact Info - Axon Muscle
export const CONTACT_INFO = {
  phone: '(833) 631-4657',
  email: 'contact@axonmuscle.com',
  corpName: 'Axon Muscle',
  address: {
    street: '460 NE 28th St',
    city: 'Miami',
    state: 'FL',
    zip: '33137',
    country: 'United States'
  }
};

// Return Address
export const RETURN_ADDRESS = {
  street: '30 N Gould St Ste 27689',
  city: 'Sheridan',
  state: 'WY',
  zip: '82801',
  country: 'USA'
};

// Default quantity for products
export const DEFAULT_QUANTITY = 2;

// ============================================
// CATEGORIES - 6 Premium Supplement Categories
// ============================================
export const categories = [
  {
    id: 'vitamins-wellness',
    name: 'Vitamins & Wellness',
    slug: 'vitamins-wellness',
    description: 'Essential vitamins and supplements for overall health and wellness',
    image: PLACEHOLDER_IMAGE,
    productCount: 11
  },
  {
    id: 'gummies',
    name: 'Gummies',
    slug: 'gummies',
    description: 'Delicious, easy-to-take gummy supplements for daily nutrition',
    image: PLACEHOLDER_IMAGE,
    productCount: 6
  },
  {
    id: 'protein',
    name: 'Protein',
    slug: 'protein',
    description: 'Premium protein supplements for muscle recovery and growth',
    image: PLACEHOLDER_IMAGE,
    productCount: 6
  },
  {
    id: 'muscle-builders',
    name: 'Muscle Builders & Testosterone Boosters',
    slug: 'muscle-builders',
    description: 'Advanced formulas to support lean muscle development, strength and testosterone',
    image: PLACEHOLDER_IMAGE,
    productCount: 9
  },
  {
    id: 'fat-burners',
    name: 'Fat Burners',
    slug: 'fat-burners',
    description: 'Thermogenic formulas to support metabolism and cutting phases',
    image: PLACEHOLDER_IMAGE,
    productCount: 3
  },
  {
    id: 'pre-workouts',
    name: 'Pre-Workouts',
    slug: 'pre-workouts',
    description: 'High-performance formulas to boost energy, focus, and endurance',
    image: PLACEHOLDER_IMAGE,
    productCount: 3
  }
];

// ============================================
// PRODUCTS - Updated Prices + New Bundles
// ============================================
export const products = [
  // ========================================
  // PRE-WORKOUTS
  // ========================================
  {
    id: 'horse-power-xtreme-pre-workout',
    name: 'Horse Power X-treme Pre-Workout',
    slug: 'horse-power-xtreme-pre-workout',
    sku: 'AXN-PW-003',
    price: 39.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/products/HORSEPOWERWatermelonSorbetXtremePreworkout.jpg?v=1668281651',
    badge: 'Best Seller',
    categoryId: 'pre-workouts',
    categorySlug: 'pre-workouts',
    description: 'High-performance pre-workout formula delivering clean energy, intense focus, and muscle endurance. Contains ingredients like citrulline, beta-alanine, and caffeine to maximize training output.',
    specs: {
      netWeight: '300g powder',
      servings: '30 servings'
    },
    keyBenefits: [
      'Clean, intense energy',
      'Sharp mental focus',
      'Improved muscle endurance'
    ],
    usage: 'Mix 1 scoop with 8-10 oz water 20-30 minutes before training.',
    features: ['Citrulline', 'Beta-Alanine', 'Caffeine', 'Pre-Training'],
    inStock: true
  },

  // ========================================
  // PROTEIN
  // ========================================
  {
    id: 'opto-isolean-1lb',
    name: 'Opto IsoLean Whey Protein Isolate (1 lb)',
    slug: 'opto-isolean-1lb',
    sku: 'AXN-PR-001',
    price: 19.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/isolean_1_vanilla_whey_protein_isolate.jpg?v=1725582790',
    badge: 'Popular',
    categoryId: 'protein',
    categorySlug: 'protein',
    description: 'High-quality whey protein isolate delivering ~25g of fast-absorbing protein per serving. Designed to support lean muscle growth, recovery, and fat metabolism with added glutamine, BCAAs, and CLA. Ideal for post-workout or daily protein intake.',
    specs: {
      netWeight: '1 lb (454g)',
      servings: '~13 servings'
    },
    keyBenefits: [
      '~25g fast-absorbing protein per serving',
      'Supports lean muscle growth and recovery',
      'Added BCAAs, glutamine, and CLA'
    ],
    usage: 'Mix 1 scoop with 6-8 oz of water or milk after workout or as a daily protein source.',
    features: ['Whey Isolate', '25g Protein', 'BCAA + Glutamine', 'Fast Absorption'],
    inStock: true
  },
  {
    id: 'opto-isolean-5lb',
    name: 'Opto IsoLean Whey Protein Isolate (5 lb)',
    slug: 'opto-isolean-5lb',
    sku: 'AXN-PR-002',
    price: 99.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/ISOLEAN5LBFRENCHVANILLA.jpg?v=1696147204',
    badge: 'Best Value',
    categoryId: 'protein',
    categorySlug: 'protein',
    description: 'Bulk size whey isolate with high protein content and low carbs. Supports muscle recovery, strength development, and lean physique goals. Smooth taste and easy mixing for daily use.',
    specs: {
      netWeight: '5 lb (2.27kg)',
      servings: '~65 servings'
    },
    keyBenefits: [
      'High protein, low carbs',
      'Supports muscle recovery and strength',
      'Bulk value for daily use'
    ],
    usage: 'Mix 1 scoop with 6-8 oz of water or milk post-workout or daily.',
    features: ['Whey Isolate', 'Bulk Size', 'Low Carb', '65 Servings'],
    inStock: true
  },
  {
    id: 'isolean-matcha-vanilla-latte',
    name: 'IsoLean Matcha Vanilla Latte',
    slug: 'isolean-matcha-vanilla-latte',
    sku: 'AXN-PR-003',
    price: 29.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/isolean_1_Matcha_Vanilla_Latte_Supplement.png?v=1754590211',
    badge: 'New',
    categoryId: 'protein',
    categorySlug: 'protein',
    description: 'Unique matcha-infused whey isolate combining clean energy with high-quality protein. Supports focus, recovery, and sustained performance.',
    specs: {
      netWeight: '1 lb (454g)',
      servings: '~13 servings'
    },
    keyBenefits: [
      'Matcha-powered clean energy',
      'Supports focus and recovery',
      'Sustained performance'
    ],
    usage: 'Mix 1 scoop with 6-8 oz of water, milk, or smoothie of choice.',
    features: ['Whey Isolate', 'Matcha Infused', 'Clean Energy', 'Focus + Recovery'],
    inStock: true
  },
  {
    id: 'isolean-chocolate-peanut-butter',
    name: 'IsoLean Chocolate Peanut Butter',
    slug: 'isolean-chocolate-peanut-butter',
    sku: 'AXN-PR-004',
    price: 29.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/isolean_1_peanut_butter_cup.jpg?v=1725579247',
    categoryId: 'protein',
    categorySlug: 'protein',
    description: 'Rich chocolate peanut butter flavor with high protein content. Helps build lean muscle while delivering a satisfying shake experience.',
    specs: {
      netWeight: '1 lb (454g)',
      servings: '~13 servings'
    },
    keyBenefits: [
      'High protein for lean muscle',
      'Rich, satisfying flavor',
      'Supports recovery'
    ],
    usage: 'Mix 1 scoop with 6-8 oz of water or milk post-workout.',
    features: ['Whey Isolate', 'Chocolate PB', 'Lean Muscle', 'Premium Flavor'],
    inStock: true
  },
  {
    id: 'isolean-strawberry-milkshake',
    name: 'IsoLean Strawberry Milkshake',
    slug: 'isolean-strawberry-milkshake',
    sku: 'AXN-PR-005',
    price: 29.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/isolean_1_strawberry_whey_protein_isolate.jpg?v=1725583313',
    categoryId: 'protein',
    categorySlug: 'protein',
    description: 'Classic strawberry flavor with fast-digesting whey isolate. Ideal for recovery, muscle growth, and maintaining a lean body composition.',
    specs: {
      netWeight: '1 lb (454g)',
      servings: '~13 servings'
    },
    keyBenefits: [
      'Fast-digesting whey isolate',
      'Supports muscle growth and recovery',
      'Helps maintain lean composition'
    ],
    usage: 'Mix 1 scoop with 6-8 oz of water or milk post-workout.',
    features: ['Whey Isolate', 'Strawberry', 'Fast Digesting', 'Recovery'],
    inStock: true
  },
  {
    id: 'isolean-vanilla-cream',
    name: 'IsoLean Vanilla Cream',
    slug: 'isolean-vanilla-cream',
    sku: 'AXN-PR-006',
    price: 29.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/isolean_1_vanilla_whey_protein_isolate.jpg?v=1725582790',
    categoryId: 'protein',
    categorySlug: 'protein',
    description: 'Smooth vanilla protein isolate designed for clean nutrition and easy digestion. Perfect for shakes, smoothies, or daily protein supplementation.',
    specs: {
      netWeight: '1 lb (454g)',
      servings: '~13 servings'
    },
    keyBenefits: [
      'Clean, simple nutrition',
      'Smooth, easy-to-mix flavor',
      'Easy on digestion'
    ],
    usage: 'Mix 1 scoop with 6-8 oz of water or milk for shakes, smoothies, or daily use.',
    features: ['Whey Isolate', 'Vanilla', 'Clean Nutrition', 'Easy Digestion'],
    inStock: true
  },

  // ========== MUSCLE BUILDERS & TESTOSTERONE BOOSTERS ==========
  {
    id: 'bcaa-eaa-7000',
    name: 'BCAA + EAA 7000',
    slug: 'bcaa-eaa-7000',
    sku: 'AXN-MB-001',
    price: 24.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/BCAA_EAA_Grape.jpg?v=1721833262',
    categoryId: 'muscle-builders',
    categorySlug: 'muscle-builders',
    description: 'Advanced amino acid complex combining BCAAs and EAAs to maximize muscle protein synthesis, improve recovery, and reduce fatigue during workouts.',
    specs: {
      netWeight: '300g powder',
      servings: '30 servings'
    },
    keyBenefits: [
      'Maximizes muscle protein synthesis',
      'Improves recovery and reduces fatigue',
      'Full BCAA + EAA profile'
    ],
    usage: 'Mix 1 scoop with 8-10 oz water during or after training.',
    features: ['BCAA + EAA', 'Recovery', 'Anti-Fatigue', 'Intra-Workout'],
    inStock: true
  },
  {
    id: 'creatine-monohydrate',
    name: 'Creatine Monohydrate',
    slug: 'creatine-monohydrate',
    sku: 'AXN-MB-002',
    price: 29.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/CREATINEPOWDER.png?v=1711064383',
    badge: 'Proven',
    categoryId: 'muscle-builders',
    categorySlug: 'muscle-builders',
    description: 'Clinically proven creatine formula that increases strength, power output, and muscle size while improving workout performance.',
    specs: {
      netWeight: '300g powder',
      servings: '60 servings'
    },
    keyBenefits: [
      'Increases strength and power output',
      'Builds muscle size and volume',
      'Improves workout performance'
    ],
    usage: 'Take 1 scoop (5g) daily, before or after training.',
    features: ['Pure Creatine', 'Strength', 'Power', 'Muscle Volume'],
    inStock: true
  },
  {
    id: 'mass-gainer',
    name: 'Mass Gainer',
    slug: 'mass-gainer',
    sku: 'AXN-MB-003',
    price: 49.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/MassGainerBerryWeightGainer.png?v=1714087164',
    categoryId: 'muscle-builders',
    categorySlug: 'muscle-builders',
    description: 'High-calorie formula designed for fast mass gain, providing protein, carbs, and nutrients to support muscle growth and recovery.',
    specs: {
      netWeight: '5 lb (2.27kg)',
      servings: '~16 servings'
    },
    keyBenefits: [
      'High-calorie formula for fast mass gain',
      'Protein and complex carbs blend',
      'Supports muscle growth and recovery'
    ],
    usage: 'Mix 2 scoops with 12-16 oz water or milk between meals or post-workout.',
    features: ['High Calorie', 'Mass Gain', 'Bulk Phase', 'Carbs + Protein'],
    inStock: true
  },
  {
    id: 'amino-muscle-caps',
    name: 'Amino Muscle Caps',
    slug: 'amino-muscle-caps',
    sku: 'AXN-MB-004',
    price: 38.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/Web_Bottles.jpg?v=1726537372',
    categoryId: 'muscle-builders',
    categorySlug: 'muscle-builders',
    description: 'Convenient capsule-based amino formula that supports muscle recovery, endurance, and protein synthesis without the need for shakes.',
    specs: {
      quantity: '120 capsules',
      servings: '30 servings'
    },
    keyBenefits: [
      'Supports muscle recovery and endurance',
      'Boosts protein synthesis',
      'Convenient capsule form — no shake needed'
    ],
    usage: 'Take 4 capsules pre or post-workout.',
    features: ['Capsule', 'Aminos', 'Recovery', 'Endurance'],
    inStock: true
  },
  {
    id: 'pump-caps',
    name: 'Pump Caps',
    slug: 'pump-caps',
    sku: 'AXN-MB-005',
    price: 69.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/Pump_Caps.png?v=1728327430',
    badge: 'Premium',
    categoryId: 'muscle-builders',
    categorySlug: 'muscle-builders',
    description: 'Advanced pump and nitric oxide booster designed to increase blood flow, enhance muscle fullness, and improve training intensity.',
    specs: {
      quantity: '90 capsules',
      servings: '30 servings'
    },
    keyBenefits: [
      'Boosts nitric oxide and blood flow',
      'Enhances muscle pumps and fullness',
      'Improves training intensity'
    ],
    usage: 'Take 3 capsules 30 minutes before training.',
    features: ['Pump', 'Nitric Oxide', 'Vasodilation', 'Pre-Workout Boost'],
    inStock: true
  },
  {
    id: 'muscle-gummies',
    name: 'Muscle Gummies',
    slug: 'muscle-gummies',
    sku: 'AXN-MB-006',
    price: 39.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/MuscleGummiesMuscleGrowthAnabolicWorkout.png?v=1714436946',
    badge: 'New',
    categoryId: 'muscle-builders',
    categorySlug: 'muscle-builders',
    description: 'Innovative gummy supplement that supports muscle growth and recovery in a convenient and tasty format.',
    specs: {
      quantity: '60 gummies',
      servings: '30 servings'
    },
    keyBenefits: [
      'Supports muscle growth and recovery',
      'Convenient and tasty gummy format',
      'Easy to take anywhere'
    ],
    usage: 'Take 2 gummies daily.',
    features: ['Gummy', 'Muscle Growth', 'Recovery', 'Convenient'],
    inStock: true
  },
  {
    id: 'optotest-x4',
    name: 'OptoTest x4',
    slug: 'optotest-x4',
    sku: 'AXN-MB-007',
    price: 79.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/OptoTestx4TestosteroneBooster.png?v=1717147743',
    badge: 'Test Booster',
    categoryId: 'muscle-builders',
    categorySlug: 'muscle-builders',
    description: 'Premium testosterone booster formulated with natural extracts to increase testosterone levels, improve strength, stamina, and overall performance.',
    specs: {
      quantity: '120 capsules',
      servings: '30 servings'
    },
    keyBenefits: [
      'Boosts natural testosterone levels',
      'Improves strength and stamina',
      'Enhances overall performance'
    ],
    usage: 'Take 4 capsules daily.',
    features: ['Testosterone Booster', 'Strength', 'Stamina', 'Natural Extracts'],
    inStock: true
  },
  {
    id: 'opto-cleanse-pct',
    name: 'Opto Cleanse PCT',
    slug: 'opto-cleanse-pct',
    sku: 'AXN-MB-008',
    price: 34.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/PCTOPTOPCTCLEANSE.png?v=1716732666',
    categoryId: 'muscle-builders',
    categorySlug: 'muscle-builders',
    description: 'Post-cycle support formula designed to help restore hormonal balance and support recovery after intense training phases.',
    specs: {
      quantity: '60 capsules',
      servings: '30 servings'
    },
    keyBenefits: [
      'Supports post-cycle hormonal balance',
      'Aids recovery after intense phases',
      'Helps maintain gains'
    ],
    usage: 'Take 2 capsules daily.',
    features: ['PCT', 'Hormonal Balance', 'Recovery Support', 'Post-Cycle'],
    inStock: true
  },
  {
    id: 'estro-shield',
    name: 'Estro Shield',
    slug: 'estro-shield',
    sku: 'AXN-MB-009',
    price: 69.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/EstroShieldEstrogenBlocker.jpg?v=1705690139',
    categoryId: 'muscle-builders',
    categorySlug: 'muscle-builders',
    description: 'Estrogen control formula designed to support hormonal balance and optimize testosterone levels for better performance and physique.',
    specs: {
      quantity: '60 capsules',
      servings: '30 servings'
    },
    keyBenefits: [
      'Supports estrogen control',
      'Optimizes testosterone levels',
      'Promotes a leaner physique'
    ],
    usage: 'Take 2 capsules daily.',
    features: ['Estrogen Control', 'Test Optimization', 'Physique Support', 'Hormonal Balance'],
    inStock: true
  },

  // ========== FAT BURNERS ==========
  {
    id: 'shreds',
    name: 'Shreds',
    slug: 'shreds',
    sku: 'AXN-PW-001',
    price: 59.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/products/FRUITPUNCH.png?v=1665736927',
    badge: 'Hot',
    categoryId: 'pre-workouts',
    categorySlug: 'pre-workouts',
    description: 'Advanced pre-workout and fat-burning formula designed to boost energy, focus, and endurance. Helps you train harder and longer while supporting fat loss and muscle preservation.',
    specs: {
      netWeight: '300g powder',
      servings: '30 servings'
    },
    keyBenefits: [
      'Boosts energy, focus and endurance',
      'Supports fat loss and muscle preservation',
      'Train harder and longer'
    ],
    usage: 'Mix 1 scoop with 8-10 oz water 20-30 minutes before training.',
    features: ['Pre-Workout', 'Thermogenic', 'Energy + Focus', 'Cutting Phase'],
    inStock: true
  },
  {
    id: 'shreds-pm',
    name: 'Shreds PM',
    slug: 'shreds-pm',
    sku: 'AXN-PW-002',
    price: 49.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/products/ShredsPmFRUITPUNCHPM.jpg?v=1668996899',
    badge: 'Stim-Free',
    categoryId: 'pre-workouts',
    categorySlug: 'pre-workouts',
    description: 'Stimulant-free pre-workout designed for evening training. Enhances strength, endurance, and focus without caffeine, making it ideal for late workouts and recovery support.',
    specs: {
      netWeight: '300g powder',
      servings: '30 servings'
    },
    keyBenefits: [
      'Stim-free energy and focus',
      'Enhances strength and endurance',
      'Ideal for evening training and recovery'
    ],
    usage: 'Mix 1 scoop with 8 oz water 30 minutes before evening training or before bed.',
    features: ['Stim-Free', 'Pre-Workout', 'Evening Use', 'Recovery'],
    inStock: true
  },
  {
    id: 'shreds-caps',
    name: 'Shreds Caps',
    slug: 'shreds-caps',
    sku: 'AXN-FB-003',
    price: 39.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/ShredsCapsFatBurner.png?v=1720458764',
    categoryId: 'fat-burners',
    categorySlug: 'fat-burners',
    description: 'Convenient capsule-based fat burner that increases thermogenesis, boosts energy, and supports appetite control throughout the day.',
    specs: {
      quantity: '90 capsules',
      servings: '30 servings'
    },
    keyBenefits: [
      'Increases thermogenesis',
      'Boosts daily energy',
      'Supports appetite control'
    ],
    usage: 'Take 3 capsules daily, preferably in the morning.',
    features: ['Capsule', 'Thermogenic', 'Appetite Control', 'Daily Use'],
    inStock: true
  },
  {
    id: 'keto-bhb',
    name: 'Keto BHB',
    slug: 'keto-bhb',
    sku: 'AXN-FB-004',
    price: 19.99,
    image: PLACEHOLDER_IMAGE,
    categoryId: 'fat-burners',
    categorySlug: 'fat-burners',
    description: 'Exogenous ketone formula designed to support fat burning, increase energy, and help the body stay in ketosis longer.',
    specs: {
      quantity: '60 capsules',
      servings: '30 servings'
    },
    keyBenefits: [
      'Supports fat burning',
      'Increases energy on keto',
      'Helps maintain ketosis'
    ],
    usage: 'Take 2 capsules daily on an empty stomach.',
    features: ['Exogenous Ketones', 'BHB Salts', 'Keto Support', 'Energy'],
    inStock: true
  },
  {
    id: 'slim-and-cleanse',
    name: 'Slim and Cleanse',
    slug: 'slim-and-cleanse',
    sku: 'AXN-FB-005',
    price: 27.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/Slim_Cleanse_Detox.jpg?v=1728836917',
    categoryId: 'fat-burners',
    categorySlug: 'fat-burners',
    description: 'Detox and fat-loss support formula that helps reduce bloating, improve digestion, and support weight management.',
    specs: {
      quantity: '60 capsules',
      servings: '30 servings'
    },
    keyBenefits: [
      'Reduces bloating',
      'Improves digestion',
      'Supports weight management'
    ],
    usage: 'Take 2 capsules daily before a meal.',
    features: ['Detox', 'Digestion', 'Weight Management', 'Cleanse'],
    inStock: true
  },

  // ========================================
  // VITAMINS & WELLNESS
  // ========================================
  {
    id: 'collagen-gummies',
    name: 'Collagen Gummies',
    slug: 'collagen-gummies',
    sku: 'AXN-GM-004',
    price: 17.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/CollagenGummies.png?v=1711416710',
    badge: 'New',
    categoryId: 'gummies',
    categorySlug: 'gummies',
    description: 'Promotes healthy skin, stronger hair, and joint support in an easy-to-take gummy form.',
    specs: {
      quantity: '60 gummies',
      servings: '30 servings'
    },
    keyBenefits: [
      'Supports healthy skin',
      'Strengthens hair and nails',
      'Improves joint flexibility'
    ],
    usage: 'Take 2 gummies daily with food.',
    features: ['Gummy', 'Skin & Hair', 'Joint Support', 'Daily Wellness'],
    inStock: true
  },
  {
    id: 'collagen-peptides',
    name: 'Collagen Peptides',
    slug: 'collagen-peptides',
    sku: 'AXN-VW-002',
    price: 27.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/CollagenPeptides.png?v=1728860410',
    categoryId: 'vitamins-wellness',
    categorySlug: 'vitamins-wellness',
    description: 'High-quality collagen peptides powder that supports skin elasticity, joint health, and muscle recovery. Easily mixes into drinks for a daily wellness boost.',
    specs: {
      netWeight: '300g powder',
      servings: '30 servings'
    },
    keyBenefits: [
      'Supports skin elasticity',
      'Promotes joint health',
      'Aids muscle recovery'
    ],
    usage: 'Mix 1 scoop into water, coffee, or smoothie daily.',
    features: ['Powder', 'Unflavored', 'Skin Health', 'Recovery'],
    inStock: true
  },
  {
    id: 'l-glutamine-1500',
    name: 'L-Glutamine 1500',
    slug: 'l-glutamine-1500',
    sku: 'AXN-VW-003',
    price: 19.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/GlutamineSupplement.png?v=1715956987',
    categoryId: 'vitamins-wellness',
    categorySlug: 'vitamins-wellness',
    description: 'Essential amino acid that helps speed up muscle recovery, supports gut health, and strengthens the immune system—perfect for active lifestyles.',
    specs: {
      quantity: '120 capsules',
      servings: '40 servings'
    },
    keyBenefits: [
      'Speeds muscle recovery',
      'Supports gut health',
      'Strengthens immune system'
    ],
    usage: 'Take 3 capsules daily, preferably post-workout.',
    features: ['Amino Acid', 'Recovery', 'Gut Health', 'Immune Support'],
    inStock: true
  },
  {
    id: 'l-lysine',
    name: 'L-Lysine',
    slug: 'l-lysine',
    sku: 'AXN-VW-004',
    price: 11.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/LysineL-LysineSupplement.png?v=1715821217',
    categoryId: 'vitamins-wellness',
    categorySlug: 'vitamins-wellness',
    description: 'A vital amino acid that promotes immune support, skin health, and collagen production while helping maintain overall wellness.',
    specs: {
      quantity: '90 capsules',
      servings: '90 servings'
    },
    keyBenefits: [
      'Supports immune health',
      'Promotes skin wellness',
      'Aids collagen production'
    ],
    usage: 'Take 1 capsule daily.',
    features: ['Amino Acid', 'Immune Support', 'Skin Health', 'Daily Use'],
    inStock: true
  },
  {
    id: 'magnesium-complex-6',
    name: 'Magnesium Complex 6',
    slug: 'magnesium-complex-6',
    sku: 'AXN-VW-005',
    price: 19.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/MagnesiumComplex.png?v=1730385558',
    categoryId: 'vitamins-wellness',
    categorySlug: 'vitamins-wellness',
    description: 'Advanced magnesium blend formulated to support relaxation, better sleep, muscle recovery, and nervous system balance.',
    specs: {
      quantity: '90 capsules',
      servings: '30 servings'
    },
    keyBenefits: [
      'Promotes relaxation and better sleep',
      'Supports muscle recovery',
      'Nervous system balance'
    ],
    usage: 'Take 3 capsules before bed.',
    features: ['6 Forms of Magnesium', 'Sleep Support', 'Relaxation', 'Recovery'],
    inStock: true
  },
  {
    id: 'opto-biotics',
    name: 'Opto Biotics',
    slug: 'opto-biotics',
    sku: 'AXN-VW-006',
    price: 24.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/OptoBioticsProbiotics.png?v=1716071727',
    categoryId: 'vitamins-wellness',
    categorySlug: 'vitamins-wellness',
    description: 'A powerful probiotic formula designed to improve digestion, support gut health, and boost your immune system naturally.',
    specs: {
      quantity: '60 capsules',
      servings: '60 servings'
    },
    keyBenefits: [
      'Improves digestion',
      'Supports gut health',
      'Boosts immune system'
    ],
    usage: 'Take 1 capsule daily.',
    features: ['Probiotic', 'Digestion', 'Gut Health', 'Immune Support'],
    inStock: true
  },
  {
    id: 'opto-omega-3',
    name: 'Opto Omega-3',
    slug: 'opto-omega-3',
    sku: 'AXN-VW-007',
    price: 11.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/Omega-3_Fish_Oil.jpg?v=1722114585',
    categoryId: 'vitamins-wellness',
    categorySlug: 'vitamins-wellness',
    description: 'Premium omega-3 fatty acids to support heart health, brain function, and overall wellness. A daily essential for a balanced lifestyle.',
    specs: {
      quantity: '60 softgels',
      servings: '30 servings'
    },
    keyBenefits: [
      'Supports heart health',
      'Boosts brain function',
      'Promotes overall wellness'
    ],
    usage: 'Take 2 softgels daily with food.',
    features: ['Fish Oil', 'EPA & DHA', 'Heart Health', 'Brain Health'],
    inStock: true
  },
  {
    id: 'sea-moss',
    name: 'Sea Moss',
    slug: 'sea-moss',
    sku: 'AXN-VW-008',
    price: 19.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/products/SeaMoss.jpg?v=1665911402',
    categoryId: 'vitamins-wellness',
    categorySlug: 'vitamins-wellness',
    description: 'Nutrient-rich sea moss supplement packed with essential minerals to support energy, immunity, and overall vitality.',
    specs: {
      quantity: '90 capsules',
      servings: '45 servings'
    },
    keyBenefits: [
      'Rich in essential minerals',
      'Supports energy and immunity',
      'Boosts overall vitality'
    ],
    usage: 'Take 2 capsules daily.',
    features: ['Superfood', 'Mineral Rich', 'Energy', 'Immunity'],
    inStock: true
  },
  {
    id: 'shilajit',
    name: 'Shilajit',
    slug: 'shilajit',
    sku: 'AXN-VW-009',
    price: 29.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/Shilajit.png?v=1712722117',
    badge: 'Adaptogen',
    categoryId: 'vitamins-wellness',
    categorySlug: 'vitamins-wellness',
    description: 'Natural adaptogen known for boosting energy, enhancing stamina, and supporting hormonal balance and overall performance.',
    specs: {
      quantity: '60 capsules',
      servings: '60 servings'
    },
    keyBenefits: [
      'Boosts energy and stamina',
      'Supports hormonal balance',
      'Enhances overall performance'
    ],
    usage: 'Take 1 capsule daily.',
    features: ['Adaptogen', 'Energy', 'Stamina', 'Performance'],
    inStock: true
  },
  {
    id: 'snoozy-dozy',
    name: 'Snoozy Dozy',
    slug: 'snoozy-dozy',
    sku: 'AXN-VW-010',
    price: 29.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/SnoozyDozySleepSupportFront.png?v=1711503601',
    categoryId: 'vitamins-wellness',
    categorySlug: 'vitamins-wellness',
    description: 'Sleep support formula designed to help you fall asleep faster, stay asleep longer, and wake up feeling refreshed and recovered.',
    specs: {
      quantity: '60 capsules',
      servings: '30 servings'
    },
    keyBenefits: [
      'Helps you fall asleep faster',
      'Promotes deeper, longer sleep',
      'Wake up refreshed and recovered'
    ],
    usage: 'Take 2 capsules 30 minutes before bed.',
    features: ['Sleep Aid', 'Recovery', 'Restorative', 'Nighttime'],
    inStock: true
  },
  {
    id: 'super-ashwagandha-turmeric-ginger-gummies',
    name: 'Super Ashwagandha + Turmeric and Ginger Gummies',
    slug: 'super-ashwagandha-turmeric-ginger-gummies',
    sku: 'AXN-GM-005',
    price: 19.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/products/Ashwagandha.jpg?v=1647643559',
    categoryId: 'gummies',
    categorySlug: 'gummies',
    description: 'A powerful anti-stress blend designed to support relaxation, reduce inflammation, and improve overall balance.',
    specs: {
      quantity: '60 gummies',
      servings: '30 servings'
    },
    keyBenefits: [
      'Promotes relaxation and stress relief',
      'Reduces inflammation',
      'Supports overall wellness'
    ],
    usage: 'Take 2 gummies daily.',
    features: ['Gummy', 'Adaptogen', 'Anti-Inflammatory', 'Stress Relief'],
    inStock: true
  },
  {
    id: 'super-immune',
    name: 'Super Immune',
    slug: 'super-immune',
    sku: 'AXN-VW-012',
    price: 69.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/products/SUPERIMMUNEImmuneImmunity.jpg?v=1668324799',
    badge: 'Premium',
    categoryId: 'vitamins-wellness',
    categorySlug: 'vitamins-wellness',
    description: 'Advanced immune support formula packed with essential vitamins, minerals, and antioxidants to help defend your body year-round.',
    specs: {
      quantity: '90 capsules',
      servings: '30 servings'
    },
    keyBenefits: [
      'Year-round immune defense',
      'Packed with vitamins and minerals',
      'Antioxidant support'
    ],
    usage: 'Take 3 capsules daily.',
    features: ['Immune Support', 'Antioxidants', 'Vitamins', 'Minerals'],
    inStock: true
  },
  {
    id: 'super-quercetin',
    name: 'Super Quercetin',
    slug: 'super-quercetin',
    sku: 'AXN-VW-013',
    price: 19.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/Quercetin_Super_95.png?v=1728499486',
    categoryId: 'vitamins-wellness',
    categorySlug: 'vitamins-wellness',
    description: 'Powerful antioxidant supplement that supports immune health, reduces inflammation, and protects cells from oxidative stress.',
    specs: {
      quantity: '60 capsules',
      servings: '60 servings'
    },
    keyBenefits: [
      'Powerful antioxidant',
      'Reduces inflammation',
      'Protects cells from oxidative stress'
    ],
    usage: 'Take 1 capsule daily.',
    features: ['Antioxidant', 'Immune Health', 'Anti-Inflammatory', 'Cellular Support'],
    inStock: true
  },
  {
    id: 'superfoods-gummies',
    name: 'Superfoods Gummies',
    slug: 'superfoods-gummies',
    sku: 'AXN-GM-006',
    price: 19.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/superfoodred_greenfront.png?v=1712878955',
    categoryId: 'gummies',
    categorySlug: 'gummies',
    description: 'A nutrient-rich blend of superfoods to support energy, immunity, and daily wellness in a tasty gummy format.',
    specs: {
      quantity: '60 gummies',
      servings: '30 servings'
    },
    keyBenefits: [
      'Energy support',
      'Boosts immunity',
      'Daily nutritional balance'
    ],
    usage: 'Take 2 gummies daily.',
    features: ['Gummy', 'Superfoods', 'Energy', 'Daily Wellness'],
    inStock: true
  },

  // ========================================
  // GUMMIES (additional)
  // ========================================
  {
    id: 'adult-multi-vitamin-gummies',
    name: 'Adult Multi-Vitamin Gummies',
    slug: 'adult-multi-vitamin-gummies',
    sku: 'AXN-GM-001',
    price: 12.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/AdultMultiGummyOrange.png?v=1710199216',
    categoryId: 'gummies',
    categorySlug: 'gummies',
    description: 'Daily multivitamin gummies packed with essential nutrients to support energy, immunity, and overall health in a convenient and delicious format.',
    specs: {
      quantity: '60 gummies',
      servings: '30 servings'
    },
    keyBenefits: [
      'Supports daily energy',
      'Boosts immune function',
      'Complete nutrient profile'
    ],
    usage: 'Take 2 gummies daily.',
    features: ['Gummy', 'Multivitamin', 'Daily Wellness', 'Immune Support'],
    inStock: true
  },
  {
    id: 'apple-cider-vinegar-gummies',
    name: 'Apple Cider Vinegar Gummies',
    slug: 'apple-cider-vinegar-gummies',
    sku: 'AXN-GM-002',
    price: 19.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/AppleCiderVinegarGummies.png?v=1710200171',
    categoryId: 'gummies',
    categorySlug: 'gummies',
    description: 'Supports digestion, metabolism, and weight management with a great taste—no harsh liquid vinegar needed.',
    specs: {
      quantity: '60 gummies',
      servings: '30 servings'
    },
    keyBenefits: [
      'Supports healthy digestion',
      'Boosts metabolism',
      'Aids weight management'
    ],
    usage: 'Take 2 gummies daily.',
    features: ['Gummy', 'ACV', 'Metabolism', 'Digestion'],
    inStock: true
  },
  {
    id: 'charcoal-gummies',
    name: 'Charcoal Gummies',
    slug: 'charcoal-gummies',
    sku: 'AXN-GM-003',
    price: 19.99,
    image: 'https://cdn.shopify.com/s/files/1/0586/2290/2425/files/charcoalgummies.png?v=1710542803',
    categoryId: 'gummies',
    categorySlug: 'gummies',
    description: 'Activated charcoal formula that helps reduce bloating, supports digestion, and promotes detox balance.',
    specs: {
      quantity: '60 gummies',
      servings: '30 servings'
    },
    keyBenefits: [
      'Reduces bloating',
      'Supports digestion',
      'Promotes detox balance'
    ],
    usage: 'Take 2 gummies daily.',
    features: ['Gummy', 'Activated Charcoal', 'Detox', 'Digestion'],
    inStock: true
  }
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  {
    id: 1,
    title: 'Premium Formulas',
    description: 'Every product engineered for maximum results'
  },
  {
    id: 2,
    title: 'Lab Tested',
    description: 'Third-party verified for purity and potency'
  },
  {
    id: 3,
    title: 'Science-Backed',
    description: 'Formulated based on latest research'
  },
  {
    id: 4,
    title: 'Fast USA Shipping',
    description: 'Free shipping on orders over $99'
  }
];

// ============================================
// STEPS (How it works)
// ============================================
export const steps = [
  {
    id: 1,
    title: 'Browse Our Supplements',
    description: 'Explore our curated selection of premium supplements designed for peak performance.'
  },
  {
    id: 2,
    title: 'Choose Your Goals',
    description: "Select supplements based on your goals—whether it's muscle growth, energy, fat loss, or overall wellness."
  },
  {
    id: 3,
    title: 'Secure Checkout',
    description: 'Complete your purchase with confidence through our safe and seamless checkout process.'
  },
  {
    id: 4,
    title: 'Fast Delivery',
    description: 'Your supplements are carefully packed and shipped fast, so you can start crushing your goals.'
  }
];
